/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Directive, OnDestroy, OnInit, Self} from '@angular/core';
import {NgModel} from '@angular/forms';
import {Subscription} from 'rxjs';

@Directive({
  standalone: false,
  selector: '[adnHttpPrefixer]'
})
export class HttpPrefixerDirective implements OnInit, OnDestroy {
  private sub: Subscription;

  constructor(@Self() private ngModel: NgModel) {}

  ngOnInit(): void {
    this.sub = this.ngModel.valueChanges.subscribe((value: string) => {
      if (value
        && !/^(https?:\/\/|mailto:|tel:|\/)/i.test(value)
        && value.toLowerCase().indexOf('<script') === -1
        && 'http://'.indexOf(value) === -1
        && 'mailto:'.indexOf(value) === -1
        && 'tel:'.indexOf(value) === -1
        && 'https://'.indexOf(value) === -1) {
        this.ngModel.control.setValue('https://' + value, {emitEvent: false});
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
